import styled from 'styled-components';

export const VideoItem = styled.div`
  div.player {
    width: 100%;
    max-width: 100%;
  }
  div.video-container {
    border-radius: 24px;
  }
`;
export const LiveAuctionVideosContentWrapper = styled.div``;
